import React from 'react';
import {
  StapleTable,
  StapleTableBody,
  StapleTableHeader,
  StapleTableHeading,
  StapleTableRow,
} from '@insurancemenu/imenu-components-lib';
import { ReplicatedInfoItem, ReplicatedInfoItemWithId } from 'store/modules/dynamic-form/replicatedInfoDelegate';
import InfoCardTableRow from './InfoCardTableRow';
import { ReplicatedInfoTableColumn } from '..';

interface Props<ItemType extends ReplicatedInfoItem> {
  items: ReplicatedInfoItemWithId<ItemType>[];
  columns: ReplicatedInfoTableColumn<ItemType>[];
  onEditItem: (itemId: string, item: ItemType) => void;
  onDeleteItem: (id: string) => void;
}

function InfoCardsTable<ItemType extends ReplicatedInfoItem>({
  items,
  columns,
  onEditItem,
  onDeleteItem,
}: Props<ItemType>): React.ReactNode {
  return (
    <StapleTable totalElements={items.length} minHeight="20rem" maxHeight="none">
      <StapleTableHeader>
        <StapleTableRow>
          {columns.map((col, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <StapleTableHeading key={`column-${index}`} width={col.width}>
              {col.title}
            </StapleTableHeading>
          ))}
          <StapleTableHeading width="6rem" />
        </StapleTableRow>
      </StapleTableHeader>
      <StapleTableBody>
        {items.map((item) => (
          <InfoCardTableRow
            key={`row-${item.id}`}
            item={item}
            columns={columns}
            onEdit={() => onEditItem(item.id, item)}
            onDelete={onDeleteItem}
          />
        ))}
      </StapleTableBody>
    </StapleTable>
  );
}

export default InfoCardsTable;
